// extracted by mini-css-extract-plugin
export var accordion = "_b9-0";
export var chevron = "_b9-3";
export var closed = "_b9-2";
export var content = "_b9-4";
export var open = "_b9-1";
export var rotate = "_b9-5";